import { render, staticRenderFns } from "./SaleQuotationDetail.vue?vue&type=template&id=3d46501b&"
import script from "./SaleQuotationDetail.vue?vue&type=script&lang=js&"
export * from "./SaleQuotationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\manla\\Downloads\\b\\public_html\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d46501b')) {
      api.createRecord('3d46501b', component.options)
    } else {
      api.reload('3d46501b', component.options)
    }
    module.hot.accept("./SaleQuotationDetail.vue?vue&type=template&id=3d46501b&", function () {
      api.rerender('3d46501b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/SaleQuotationDetail.vue"
export default component.exports